export default __webpack_public_path__ + "static/media/PlusIcon.67c59141.svg";